export default function visibilityEventSource(store) {
    store.dispatch({
        type: "VISIBILITY_STATE_CHANGE",
        visibilityState: document.visibilityState})

    document.addEventListener("visibilitychange", function() {
        store.dispatch({
            type: "VISIBILITY_STATE_CHANGE",
            visibilityState: document.visibilityState})
    }, false);
}



// WEBPACK FOOTER //
// ./src/middleware/visibilityMiddleware.js